import DateRangePicker, {LOCK_UNAVAILABLE, LOCK_LOCKED, LOCK_OVERLAP_AVAILABLE} from 'components/daterangepicker-wrapper';
import {isMobile, delay} from 'methods/utils';
import Layout from 'components/layout';

export {
    LOCK_LOCKED,
    LOCK_UNAVAILABLE,
    LOCK_OVERLAP_AVAILABLE,
}

function DateRangePickerDropdown($element, options = {}) {
    // ссылка на экземпляр
    if ($element.instance) {
        return $element.instance;
    }
    $element.instance = this;

    // определение мобилки
    Object.defineProperty(this, '_isMobile', {
        get: () => isMobile(),
    });

    // автоподтверждение выбранных дат
    this._autoApply = !this._isMobile;

    this._disableCallbacks = false;

    const datepickerHeader = options.datepickerHeader || this._isMobile;

    if (!Object.prototype.hasOwnProperty.call(options, 'canShowPlate')) {
        options.canShowPlate = true;
    }

    this._$dropdown = this._$createElement(
        `<div class="Daterangepicker-dropdown${options.datepickerPosition ? ' ' + options.datepickerPosition : ''}">
            ${datepickerHeader ?
                `<div class="Daterangepicker-dropdown__header">
                    <div class="Daterangepicker-dropdown__header-close">
                        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 8L2 8M2 8L8.5 14.5M2 8L8.5 1.5" stroke="currentColor" stroke-width="2"/>
                        </svg>
                    </div>
                    <div class="Daterangepicker-dropdown__header-title">Даты поездки</div>
                    <div class="Daterangepicker-dropdown__header-subtitle js-errorMessage is-hidden"></div>
                </div>` : ''
            }
            <div class="Daterangepicker-dropdown__wrapper"></div>
            <div class="Daterangepicker-dropdown__footer">
                <div class="Daterangepicker-dropdown__confirm">
                    <div class="Daterangepicker-dropdown__confirm-button">
                        Применить
                    </div>
                </div>
            </div>
            ${!isMobile() && options.canShowPlate ? 
                `<div class="Daterangepicker-dropdown__plate">
                    Выберите даты, покажем лучшие цены, акции, скидки
                </div>` 
            : ''}
        </div>`
    );
    this._$dropdownWrapper = this._$dropdown.querySelector('.Daterangepicker-dropdown__wrapper');
    this._$errorMessage = this._$dropdown.querySelector('.js-errorMessage');

    if (typeof options.$inputDateStart != 'undefined') {
        this._$inputDateStart = options.$inputDateStart;
        delete options.$inputDateStart;
    }

    if (typeof options.$inputDateFinish != 'undefined') {
        this._$inputDateFinish = options.$inputDateFinish;
        delete options.$inputDateFinish;
    }

    // кастомный вывод дат
    if (options.customTitleFormatter) {
        this.customTitleFormatter = options.customTitleFormatter;
    }

    // кастомный title если даты не введены
    this.defaultTitle = 'Дата';
    if (options.defaultTitle) {
        this.defaultTitle = options.defaultTitle;
    }

    this._formInputClass = options.formInputClass || 'Form-input';
    delete options.formInputClass;

    // элементы
    this._$element         = $element;
    this._$inputDateStart  = this._$inputDateStart  || this._$element.querySelector('input[name="date_start"]');
    this._$inputDateFinish = this._$inputDateFinish || this._$element.querySelector('input[name="date_finish"]');
    this._$labelDateStart  = this._$element.querySelector('[data-name="date_start"]');
    this._$labelDateFinish = this._$element.querySelector('[data-name="date_finish"]');
    this._$rangeReset = this._$element.querySelector('.js-rangeReset');

    // form="form_map"
    if (options.formId) {
        this._$inputDateStart.setAttribute('form', options.formId);
        this._$inputDateFinish.setAttribute('form', options.formId);
    }

    /////////////
    // мобилка //
    /////////////

    // закрытие модалки
    this._$close = this._$dropdown.querySelector('.Daterangepicker-dropdown__header-close');
    if (this._$close) {
        this._$close.addEventListener('click', this.close.bind(this));
    }

    // контейнер для элемента датапикера
    this._$dropdownFooter        = this._$dropdown.querySelector('.Daterangepicker-dropdown__footer');
    this._$dropdownConfirmButton = this._$dropdown.querySelector('.Daterangepicker-dropdown__confirm-button');

    // плашка
    this._$dropdownPlate = this._$dropdown.querySelector('.Daterangepicker-dropdown__plate');

    // обновление видимости футера модалки при прокрутке
    this._$dropdownWrapper.addEventListener('scroll', this.updateFooterVisibility.bind(this));

    // кнопка подтверждения
    if (this._$dropdownConfirmButton) {
        this._$dropdownConfirmButton.addEventListener('click', this.apply.bind(this));
    }

    // наследуемся
    DateRangePicker.call(this, this._$dropdownWrapper, Object.assign({}, options, {
        monthsCount: 2,
        singleMode: false,
        internalInputs: false, // запрещаем встроенные поля ввода, у нас свои
    }));

    // предвыбранные даты
    if (this._$inputDateStart.value && this._$inputDateFinish.value) {
        this.rangeSelect(new Date(this._$inputDateStart.value), new Date(this._$inputDateFinish.value));

        // для мобилки
        this.apply();
    }

    // сброс дат
    if (this._$rangeReset) {
        this._$rangeReset.addEventListener('click', this.rangeReset.bind(this));
    }

    // обёртка элементов
    this._$element.appendChild(this._$dropdown);
    this._$element.addEventListener('click', this._onClickEvent.bind(this));

    window.addEventListener('resize', this._onResizeEvent.bind(this));
    this._onResizeEvent();

    const info = [];

    const hasEqualMinStay = this.restrictions.every(restriction => restriction.min_stay) && this.restrictions.map(restriction => restriction.min_stay).filter((value, index, array) => array.indexOf(value) == index).length == 1;
    const hasEqualMinStayArrival = this.restrictions.every(restriction => restriction.min_stay_arrival) && this.restrictions.map(restriction => restriction.min_stay_arrival).filter((value, index, array) => array.indexOf(value) == index).length == 1;
    const hasEqualMaxStay = this.restrictions.every(restriction => restriction.max_stay) && this.restrictions.map(restriction => restriction.max_stay).filter((value, index, array) => array.indexOf(value) == index).length == 1;

    if (hasEqualMinStay) {
        info.push(`Минимальный срок проживания ${this.plural(this.restrictions[0].min_stay, ['%d ночь', '%d ночи', '%d ночей'])}`);
    } else if (hasEqualMinStayArrival) {
        info.push(`Минимальный срок проживания ${this.plural(this.restrictions[0].min_stay_arrival, ['%d ночь', '%d ночи', '%d ночей'])}`);
    }

    if (hasEqualMaxStay) {
        info.push(`Максимальный срок проживания ${this.plural(this.restrictions[0].max_stay, ['%d ночь', '%d ночи', '%d ночей'])}`);
    }

    if (info.length) {
        this.errorMessage(info.join("\n"));
    }
}

// цепочка прототипов
DateRangePickerDropdown.prototype = Object.create(DateRangePicker.prototype, {
    constructor: {
        value: DateRangePickerDropdown,
        enumerable: false,
        writable: true,
    }
});

/**
 * Инициализация компонента
 */
DateRangePickerDropdown.prototype.init = function() {
    DateRangePicker.prototype.init.call(this);

    this._togglePlate();

    // плавные анимации
    this._$dropdown.classList.add('is-initialized');
}

/**
 * Событие клика на контейнер
 * @param {Event} e DOM событие
 */
DateRangePickerDropdown.prototype._onClickEvent = function(e) {
    this.open();
}

/**
 * Событие клика вне элемента
 * @param {Event} e DOM событие
 */
DateRangePickerDropdown.prototype._onDocumentClickEvent = function(e) {
    if (this._$dropdown.contains(e.target)) {
        return;
    }

    this.close();
}

/**
 * Показ элемента
 */
DateRangePickerDropdown.prototype.open = function() {
    if (this._$dropdown.classList.contains('is-opened')) {
        return;
    }
    this._$dropdown.classList.add('is-opened');

    this._callback('open');
    this._callback('openDatepicker');

    this.scrollToRelevantMonthOnOpen();

    // мобилка
    if (this._isMobile) {
        const $documentHeader = document.querySelector('.js-header');
        if ($documentHeader) {
            $documentHeader.classList.add('is-hidden');
        }

        Layout.scroll.disable('daterangepicker-dropdown');

        // прокрутка до предвыбранных дат
        const $dayFrom = this._$dropdown.querySelector('.is-selected-from');
        if ($dayFrom) {
            $dayFrom.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            });
        }

        // манипуляции с историей браузера
        window.history.pushState({
            daterangepicker: true,
        }, 'Выбор дат');
        this._onPopStateEventBind = this._onPopStateEvent.bind(this);
        window.addEventListener('popstate', this._onPopStateEventBind);
    }

    // обновление позиции подсказки
    this._tooltipUpdate();

    // позволяем событию завершиться
    if (!this._onDocumentClickEventBind) {
        this._onDocumentClickEventBind = this._onDocumentClickEvent.bind(this);
        setTimeout(() => {
            document.addEventListener('click', this._onDocumentClickEventBind);
        }, 0);
    }
}

/**
 * Скрытие элемента
 */
DateRangePickerDropdown.prototype.close = function() {
    if (!this._$dropdown.classList.contains('is-opened')) {
        return;
    }

    // мобилка
    if (this._isMobile) {
        const $documentHeader = document.querySelector('.js-header');
        if ($documentHeader) {
            $documentHeader.classList.remove('is-hidden');
        }

        Layout.scroll.enable('daterangepicker-dropdown');

        // манипуляции с историей браузера
        window.removeEventListener('popstate', this._onPopStateEventBind);
    }

    if (this._onDocumentClickEventBind) {
        document.removeEventListener('click', this._onDocumentClickEventBind);
        delete this._onDocumentClickEventBind;
    }

    this._callback('close');
    this._callback('closeDatepicker');

    // позволяем событию завершиться
    setTimeout(() => {
        this._$dropdown.classList.remove('is-opened');

        if (!this._autoApply) {
            // необходимость ручного подтверждения выбора дат
            delete this._enableRangeSelectCallback;

            // выбираем последние подтверждённые даты
            if (this._lastAppliedDateFrom && this._lastAppliedDateTo) {
                setTimeout(() => {
                    this._selection.date_from = this._lastAppliedDateFrom;
                    this._selection.date_to = this._lastAppliedDateTo;
                    this._rangeVisualSelect(this._lastAppliedDateFrom, this._lastAppliedDateTo);
                }, 200);
            }
        }
    }, 0);
}

/**
 * Событие сброса выделения
 */
DateRangePickerDropdown.prototype.rangeReset = function() {
    DateRangePicker.prototype.rangeReset.call(this);

    // видимость кнопки "Применить" на мобилке
    this.updateFooterVisibility();

    // видимость плашки
    this._togglePlate();

    // кнопка очистки даты
    if (this._$rangeReset) {
        this._$rangeReset.classList.toggle('is-hidden', true);
    }

    delete this._lastAppliedDateTo;
    delete this._lastAppliedDateFrom;

    this._$inputDateStart.value  = '';
    this._$inputDateFinish.value = '';
    this._$labelDateStart.innerHTML  = this.defaultTitle;
    this._$labelDateFinish.innerHTML = this.defaultTitle;
    this._$labelDateStart.classList.add(this._formInputClass + '--muted');
    this._$labelDateFinish.classList.add(this._formInputClass + '--muted');

    this._$element.dispatchEvent(new Event('change', {
        bubbles: true,
        cancelable: true,
    }));
}

/**
 * Внутрннее событие сброса выделения
 */
DateRangePickerDropdown.prototype._rangeReset = function() {
    DateRangePicker.prototype._rangeReset.call(this);

    // видимость кнопки "Применить" на мобилке
    this.updateFooterVisibility();

    // видимость плашки
    this._togglePlate();
}

/**
 * Выбор диапазона дат
 * @param {Date} date_from Начальная дата
 * @param {Date} date_to   Конечная дата
 */
DateRangePickerDropdown.prototype.rangeSelect = function(date_from, date_to) {
    DateRangePicker.prototype.rangeSelect.call(this, date_from, date_to);

    // видимость кнопки "Применить" на мобилке
    this.updateFooterVisibility();

    // видимость плашки
    this._togglePlate();

    // кнопка очистки даты
    if (this._$rangeReset) {
        this._$rangeReset.classList.toggle('is-hidden', false);
    }

    if (this._autoApply) {
        this.apply();
    }
}

DateRangePicker.prototype.todaySelect = function() {
    const today     = new Date();
    const nextDay   = new Date();
    const autoApply = this._autoApply;

    nextDay.setDate(nextDay.getDate() + 1);

    this.rangeSelect(today, nextDay);

    this._autoApply = true;
    this.apply();
    this._autoApply = autoApply;
}

DateRangePicker.prototype.nextDaySelect = function() {
    const nextDay   = new Date();
    const nextDay2  = new Date();
    const autoApply = this._autoApply;

    nextDay.setDate(nextDay.getDate() + 1);
    nextDay2.setDate(nextDay.getDate() + 1);

    this.rangeSelect(nextDay, nextDay2);

    this._autoApply = true;
    this.apply();
    this._autoApply = autoApply;
}

/**
 * Safe вызов внешних событий компонента
 * @param {String} f Имя события
 */
DateRangePickerDropdown.prototype._callback = function(f) {
    // на мобилке событие rangeSelect вызывается только по кнопке "Применить"
    if (!this._autoApply && f == 'rangeSelect' && !this._enableRangeSelectCallback) {
        return;
    }

    if (this._disableCallbacks === true) {
        return;
    }

    DateRangePicker.prototype._callback.apply(this, arguments);
}

/**
 * Подтверждение выбора дат
 */
DateRangePickerDropdown.prototype.apply = function() {
    const date_from = this.getDateFrom();
    const date_to   = this.getDateTo();

    this._lastAppliedDateFrom = date_from;
    this._lastAppliedDateTo   = date_to;

    if (!date_from || !date_to) {
        return;
    }

    // на мобилке событие rangeSelect глушится т.к. требуется подтверждение по кнопке "Применить"
    if (!this._autoApply) {
        this._enableRangeSelectCallback = true;
        DateRangePicker.prototype.rangeSelect.call(this, date_from, date_to);
    }

    this._$inputDateStart.value  = this.formatDate(date_from);
    this._$inputDateFinish.value = this.formatDate(date_to);
    this._$labelDateStart.innerHTML  = this.getDateTitleFormatted(date_from);
    this._$labelDateFinish.innerHTML = this.getDateTitleFormatted(date_to);
    this._$labelDateStart.classList.remove(this._formInputClass + '--muted');
    this._$labelDateFinish.classList.remove(this._formInputClass + '--muted');

    this._$element.dispatchEvent(new Event('change', {
        bubbles: true,
        cancelable: true,
    }));

    this.close();
}

DateRangePickerDropdown.prototype._onResizeEvent = function() {
    const date_from = this.getDateFrom();
    const date_to   = this.getDateTo();

    this._$labelDateStart.innerHTML = this.getDateTitleFormatted(date_from);
    this._$labelDateFinish.innerHTML = this.getDateTitleFormatted(date_to);
}

/**
 * Форматирование даты
 * @param  {Date} date Дата
 * @return {String}    Дата в формате - 8 март, чт
 */
DateRangePickerDropdown.prototype.getDateTitleFormatted = function(date, format = '') {
    if (!date || !(date instanceof Date)) {
        return this.defaultTitle;
    }

    // решение для любого формата, че хочешь, то и пиши
    if (this.customTitleFormatter) {
        return this.customTitleFormatter(date);
    }

    const month   = new Intl.DateTimeFormat('ru-RU', {month: 'short'}).format(date).replace('.', '');
    const weekday = new Intl.DateTimeFormat('ru-RU', {weekday: 'short'}).format(date);

    return date.getDate() + ' ' + month + ', <span class="date-input__weekday">' + weekday + '</span>';
}

/**
 * Обновление состояния футера в модалке
 * скрывается при прокрутке вверх и если не выбраны даты
 */
DateRangePickerDropdown.prototype.updateFooterVisibility = function() {
    if (typeof this._dropdownContainerPrevScroll == 'undefined') {
        this._dropdownContainerPrevScroll = this._$dropdownWrapper.scrollTop;
    }

    const bothDatesSelected = !!this.getDateFrom() && !!this.getDateTo();
    const scrolledDown = this._dropdownContainerPrevScroll >= this._$dropdownWrapper.scrollTop;
    const isActive = [
        bothDatesSelected,
        // scrolledDown,
    ].every(v => v);

    this._$dropdownFooter.classList.toggle('is-active', isActive);
    this._dropdownContainerPrevScroll = this._$dropdownWrapper.scrollTop;
}

/**
 * Событие нажатия кнопки "назад" в браузере
 * @param {Event} e DOM Событие
 */
DateRangePickerDropdown.prototype._onPopStateEvent = function(e) {
    this.close();
}

/**
 * Событие нажатия кнопки "назад" в браузере
 * @param {Event} e DOM Событие
 */
DateRangePickerDropdown.prototype.errorMessage = function(message, is_active = true) {
    this._$errorMessage.classList.toggle('is-hidden', !is_active);
    this._$errorMessage.innerHTML = message.replace(/\n/g, '<br>');
}


/**
 * Событие изменения размеров окна
 * @param {Event} e DOM событие
 */
DateRangePickerDropdown.prototype._onWindowResizeEvent = function(e) {
    DateRangePicker.prototype._onWindowResizeEvent.call(this, e);

    this.setOptions({
        monthsCount: this._isMobile ? 12 : 2,
    });
}

/**
 * Есть ли выбранные даты
 * @returns {Boolean}
 */
DateRangePickerDropdown.prototype._hasDates = function() {
    return Boolean(this.getDate());
}

/**
 * Переключение плашки
 */
DateRangePickerDropdown.prototype._togglePlate = function() {
    if (!this._$dropdownPlate) return;
    
    if (this._hasDates(this)) {
        this._$dropdownPlate.classList.add('is-hidden');
    } else {
        this._$dropdownPlate.classList.remove('is-hidden');
    }
}

export default DateRangePickerDropdown;
